









































import { Module } from '@/models/configurator/module';
import { cloneDeep } from 'lodash';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'ModuleImage',

  props: {
    module: { type: Object as PropType<Module>, required: false }
  },

  methods: {
    editModule(module: Module) {
      this.$emit('edit-module', cloneDeep(module));
    },

    deleteModule(id: number) {
      this.$emit('delete-module', id);
    },

    cloneModule(module: Module) {
      this.$emit('clone-module', module);
    }
  }
});
